import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Center,
  Text,
} from "@chakra-ui/react";
import { useContaxt } from "../../context/Context";
import { ActionButton } from "../ActionButton";
import { HeadLine } from "../HeadLine";

export function FAQ() {
  const { color, marginTop, variant } = useContaxt();

  const FAQActionButton = () => {
    return (
      <ActionButton
        h={"50px"}
        fontSize={"14px"}
        w={variant === "base" ? "100%" : "250px"}
      />
    );
  };

  const FAQS = [
    {
      title: "Wie lange dauert es, bis meine Webseite fertig ist?",
      text: (
        <Box>
          <Text>
            Handelt es sich um eine kleinere Anpassung einer bestehenden
            Webseite,
            <strong>
              kann das Projekt auch innerhalb einer Woche abgeschlossen werden.
            </strong>
            <br />
            <br />
            Für eine professionelle Webseite kannst Du in der Regel{" "}
            <strong> mit 2 bis 4 Wochen rechnen</strong>, je nachdem, wie
            schnell die Texte und Bilder geliefert werden und wie umfangreich
            die Seite werden soll.
            <br />
            <br />
            <strong>
              Kontaktiere uns für ein unverbindliches Erstgespräch, in dem wir
              die Projektdauer für dich abschätzen können.
            </strong>
          </Text>
          <Box mt={4}>
            <FAQActionButton />
          </Box>
        </Box>
      ),
    },
    {
      title: "Was kostet eine Webseite?",
      text: (
        <Box>
          <Text>
            Wie bei Häusern, Autos, Booten usw. hängt der Preis einer Webseite
            von der Ausstattung ab. Wenn Du nur einen so genannten "One-Pager"
            haben möchtest, ist das Projekt günstiger, als wenn die individuelle
            Webseite mehrere Unterseiten haben soll.
            <br />
            <br />
            Vereinbare gerne ein{" "}
            <strong>
              kostenloses und unverbindliches Beratungsgespräch, in dem wir
              Deine Vorstellungen und Wünsche besprechen.
            </strong>{" "}
            Danach können wir Dir dann ein konkretes, unverbindliches Angebot
            unterbreiten. Ohne Deine Wünsche und Bedürfnisse zu kennen, ist eine
            Festpreiskalkulation reine Spekulation.
            <br />
            <br />
            Beachte bei der Preisrecherche von Webseiten, dass viele Anbieter
            lediglich Baukasten-Webseiten verkaufen. Weder die
            Individualisierbarkeit noch die Datensicherheit können bei solchen
            Systemen mit individuell geplanten und umgesetzten Webseiten
            mithalten. Auch können selbst erstellte Webseiten für 300 € nicht
            mit einem hervorragenden Webdesign und einer professionellen
            Webentwicklung mithalten.
            <br />
            <br />
            <strong>
              Wir erstellen Dir eine individuelle Webseite, die zu 100% auf
              Deine Bedürfnisse zugeschnitten ist.
            </strong>
          </Text>
          <Box mt={4}>
            <FAQActionButton />
          </Box>
        </Box>
      ),
    },
    {
      title: "Bietet ihr auch Wartung und Support an?",
      text: (
        <Box>
          <Text>
            Ja, wir bieten umfassende Wartungs- und Support-Dienstleistungen an.
            Dazu gehören regelmäßige Updates, Sicherheitschecks, Backups und
            technischer Support.
            <br />
            <br />
            <strong>
              Unser Ziel ist es, dass Deine Webseite immer optimal funktioniert
              und auf dem neuesten Stand bleibt.
            </strong>
            <br />
            <br />
            Gerne erstellen wir Dir ein individuelles Wartungspaket, das zu
            Deinen Bedürfnissen und Deinem Budget passt.
          </Text>
          <Box mt={4}>
            <FAQActionButton />
          </Box>
        </Box>
      ),
    },
    {
      title: "Kann meine alte Webseite modernisiert werden?",
      text: (
        <Box>
          <Text>
            Ja, es ist grundsätzlich möglich, Webseiten zu modernisieren. <br />
            Aber es ist wie bei der Renovierung eines Hauses oder der Reparatur
            eines Autos.
            <br /> <br />
            Nicht immer ist es sinnvoll, eine Webseite zu modernisieren, in
            manchen Fällen kann es kostengünstiger sein, die Webseite komplett
            neu zu erstellen.
            <br />
            <br />
            Zögere nicht, einen unverbindlichen Termin zu vereinbaren, damit wir
            dein Projekt bewerten können.
          </Text>
          <Box mt={4}>
            <FAQActionButton />
          </Box>
        </Box>
      ),
    },
    {
      title: "Was passiert, wenn mir das Layout nicht gefällt?",
      text: (
        <Box>
          <Text>
            <strong> Unser Ziel ist Deine Zufriedenheit.</strong> <br />
            Wir versuchen im Vorfeld so gut wie möglich Deine Vorstellungen von
            Deiner Webseite zu verstehen. Dazu zeigen wir Dir Beispiele unserer
            bisherigen Projekte oder vergleichbare Webseiten aus dem Internet,
            anhand derer wir{" "}
            <strong>
              gemeinsam herausfinden, in welchem Stil Deine neue Webseite erstellt
              werden soll.
            </strong>
            <br />
            <br />
            Während des gesamten Erstellungsprozesses bekommst Du{" "}
            <strong>regelmäßig Updates</strong> über den Zwischenstand, so dass Du
            rechtzeitig die Möglichkeit hast, Deine Wünsche zu äußern.
            <br />
            <br />
            Solltest Du am Ende dennoch unzufrieden mit Deiner neuen Webseite
            sein,{" "}
            <strong>
              nehmen wir uns die Zeit, Deine Webseite kostenlos an Deine
              Bedürfnisse anzupassen.
            </strong>
          </Text>
          <Box mt={4}>
            <FAQActionButton />
          </Box>
        </Box>
      ),
    },
  ];

  return (
    <Box mt={marginTop}>
      <HeadLine text="Häufig gestellte Fragen" />
      <Center w={"100%"} mt={"50px"}>
        <Box w={variant === "base" || variant === "sm" ? "90vw" : "70vw"}>
          <Accordion allowToggle>
            {FAQS.map((faq, index) => (
              <AccordionItem key={index}>
                <h2>
                  <AccordionButton
                    _expanded={{ bg: color.mainColor, color: "white" }}
                  >
                    <Box as="span" flex="1" textAlign="left">
                      {faq.title}
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>{faq.text}</AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </Box>
      </Center>
    </Box>
  );
}
